import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";

import dynamic from "next/dynamic"
import Image from "next/legacy/image";
import Link from "next/link";
import Box from "@mui/material/Box";
import { getCanonicalSlug, isSafari, productLink, s3Url } from "@components/config/helpers";
import useGlobalSettings from "@components/_hooks/useGlobalSettings";

const IsDesignerOriginalImage = dynamic(() => import("./IsDesignerOriginalImage"), {
    ssr: false,
});
const IsEcoFriendlyImage = dynamic(() => import("./IsEcoFriendlyImage"), {
    ssr: false,
})

const CategoryImageContainer = (props) => {
    const {
        image,
        product_name,
        product_code,
        canonical_category_slug,
        section_slug,
        package_core,
        product_slug,
        is_designer_original,
        is_eco_friendly,
        product_idx,
        on_offer,
        long_term
    } = props;

    const show_title_product_code = useSelector((state) => state.globalReducer.template_settings.show_tile_product_code) || 'no';
    const red = useSelector((state) => state.globalReducer.template_settings.show_tile_product_code)
    const agent = useSelector((state) => state.globalReducer.agent);
    const lazy = product_idx < 8 ? false : true;

    const { getSetting } = useGlobalSettings()

    const urlLink = getCanonicalSlug({ canonical_category_slug, section_slug });

    return (
        // 
        <Box
            className={`position-relative`} // newly added style due to adjustment in box-padding
            sx={{
                minHeight: '54px',
                // maxHeight:{lg:298},
                marginBottom: {
                    lg: '1rem',
                    md: '0rem',
                    xs: '0.5rem'
                },
            }}
        >
            {on_offer == 'yes' && <div className={'ribbon'}><span>ON OFFER</span></div>}
            <Link shallow={true} className={`category_anchor position-relative ${package_core && 'pointerEvent'}`} href={productLink(urlLink, product_slug, long_term)}>
                <Image
                    src={s3Url(image)}
                    alt={product_name}
                    title={product_name}
                    layout="responsive"
                    height={360}
                    width={360}
                    quality={100}
                    sizes="(max-width: 400px) 200px, 
                    (max-width: 500px) 240px, 
                    (max-width: 736px) 300px, 
                    (max-width: 900px) 400px, 
                    (max-width: 1000px) 250px, 
                    (max-width: 1200px) 300px, 
                    (max-width: 1460px) 200px, 
                    360px"
                    priority={!lazy} // Set priority based on the 'lazy' variable
                />
                {show_title_product_code == 'yes' && !isSafari(agent.user_agent) && (<Typography variant="span" component="span" className="code-on-image f-size_1">{product_code}</Typography>)}
            </Link>
            {(is_designer_original === "yes") && (
                <Link shallow={true} href={productLink(urlLink, product_slug, long_term)}>
                    <IsDesignerOriginalImage />
                </Link>
            )}
            {(getSetting('carbon_footprint', 'no') == 'yes') && is_eco_friendly !== null && is_eco_friendly !== undefined && (
                <Link shallow={true} href={productLink(urlLink, product_slug, long_term)}>
                    <IsEcoFriendlyImage />
                </Link>
            )}
        </Box>
    );
}

export default CategoryImageContainer